import { defaultHttpClient } from '../../httpClient';
import type { MarketDetail } from './types';

export const getMarketDetail = (marketId: number) => {
  return defaultHttpClient
    .request<MarketDetail>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/`,
    })
    .then(result => result.data);
};
